<template>
  <span
    >{{
      Math.floor(readTime! / 200) === 0 ? 1 : Math.floor(readTime! / 200)
    }}
    min read</span
  >
</template>

<script setup lang="ts">
import type { ISbRichtext } from "storyblok-js-client";

const props = defineProps<{
  articleContent: ISbRichtext;
}>();

const readTime = sbArticleContentSanitiser(props.articleContent).split(
  " ",
).length;
</script>
